// src/contexts/OrderStatusContext.js
import React, { createContext, useContext, useState } from "react";

const OrderStatusContext = createContext(undefined);

export const OrderStatusProvider = ({ children }) => {
  const [isOrderStatusModalOpen, setIsOrderStatusModalOpen] = useState(false);
  const [orderCode, setOrderCode] = useState(null);

  const openOrderStatusModal = (code) => {
    console.log("🔔 Abrindo modal de status para pedido:", code);
    setOrderCode(code);
    setIsOrderStatusModalOpen(true);
  };

  const closeOrderStatusModal = () => {
    console.log("🔔 Fechando modal de status");
    setIsOrderStatusModalOpen(false);
  };

  return (
    <OrderStatusContext.Provider
      value={{
        isOrderStatusModalOpen,
        orderCode,
        openOrderStatusModal,
        closeOrderStatusModal,
      }}
    >
      {children}
    </OrderStatusContext.Provider>
  );
};

export const useOrderStatus = () => {
  const context = useContext(OrderStatusContext);
  if (context === undefined) {
    throw new Error(
      "useOrderStatus must be used within an OrderStatusProvider"
    );
  }
  return context;
};
